import { render } from "./Secirity.vue?vue&type=template&id=1a9a0256&scoped=true"
import script from "./Secirity.vue?vue&type=script&lang=js"
export * from "./Secirity.vue?vue&type=script&lang=js"

import "./Secirity.vue?vue&type=style&index=0&id=1a9a0256&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9a0256"]])

export default __exports__